import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {BridgeAdUnitDemandPartnerLine} from '../../domain/bridge-ad-unit-demand-partner-line.model';
import {BridgeAdUnitDemandPartnerResponse} from '../../domain/bridge-ad-unit-demand-partner-response.model';
import {SelectionModel} from '@angular/cdk/collections';
import {
  BridgeAdUnitDpHbIdStatus,
  BridgeAdUnitDpHbIdStatusKLDemandPartners
} from '../../../shared/domain/bridge-ad-unit-hb-id-status.enum';
import {AdsTxtStatus} from '../../../shared/domain/adstxt-status.model';
import {FormControl} from '@angular/forms';
import {Publisher} from '../../../shared/domain/publisher.model';
import {GlobalSpinnerService} from '../../../shared/components/loader-service/global-spinner.service';
import {SnackBarService} from '../../../shared/services/snackbar.service';
import {DpStatsService} from '../../dp-stats.service';
import {Principal} from '../../../shared/auth/principal.service';
import {Utils} from '../../../shared/utils/utils';
import {MomentDateUtils} from '../../../shared/utils/moment-date-utils';
import {CsvExportUtils} from '../../../shared/utils/csv-export-utils';
import {HttpUtils} from '../../../shared/utils/http-utils';
import {DemandPartnerRequestDialogComponent} from '../../components/demand-partner-request-dialog.component';
import {HbCsvImportResult} from '../../domain/hb-csv-import-result.model';
import {HbCsvImportResultDialogComponent} from '../../components/hb-csv-import-result-dialog.component';
import { DemandPartnerDbName } from '../../../kitchen/shared/domain/demand-partner.enum';
@Component({
  selector: 'cm-dp-dash-units',
  templateUrl: './dp-dash-units.component.html',
  styleUrls: ['./dp-dash-units.component.scss']
})
export class DpDashUnitsComponent implements AfterViewInit, OnInit {

   @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  selection = new SelectionModel<BridgeAdUnitDemandPartnerLine>(true, []);
  dataSource = new MatTableDataSource<any>();
  data = new BridgeAdUnitDemandPartnerResponse();
  showLoadingData = false;
  AdsTxtStatus = AdsTxtStatus;
  statusesKL = BridgeAdUnitDpHbIdStatusKLDemandPartners();
  columns = [];
  filter = {
    name: '',
    nameControl: new FormControl(),
    publisherId: null,
    selectedStatuses: [
      BridgeAdUnitDpHbIdStatus.PENDING
    ],
    resetFilter: () => {
      this.filter.name = null;
      this.filter.publisherId = null;
      this.filter.selectedStatuses = [
        BridgeAdUnitDpHbIdStatus.PENDING
      ];
      this.filterData();
    }
  };
  availablePublishers: Publisher[] = [];
  isUnitActivatedAllowed = false;
  isIndexOrSovrn = false;

  constructor(private dpStatsService: DpStatsService,
              private globalSpinnerService: GlobalSpinnerService,
              private snackBarService: SnackBarService,
              private principal: Principal,
              private matDialog: MatDialog) {
    this.isUnitActivatedAllowed = [DemandPartnerDbName.INDEX, DemandPartnerDbName.RUBICON, DemandPartnerDbName.SONOBI].includes(this.principal.demandPartner.name);
    this.isIndexOrSovrn = ['index', 'sovrn'].includes(this.principal.demandPartner.name.toLowerCase());

    switch (this.principal.demandPartner.name.toLowerCase()) {
      case 'index':
        this.columns = ['select', 'bridgeAdUnitName', 'sites', 'adstxtStatus', 'unitActivated',
          'publisherName', 'status', 'hbId', 'siteId', 'createdOn', 'actions'];
        break;
      case 'sovrn':
        this.columns = ['select', 'bridgeAdUnitName', 'sites', 'adstxtStatus',
          'publisherName', 'status', 'hbId', 'siteId', 'createdOn', 'actions'];
        break;
      case 'rubicon':
      case 'sonobi':
        this.columns = ['select', 'bridgeAdUnitName', 'sites', 'unitActivated',
          'publisherName', 'status', 'hbId', 'siteId', 'createdOn', 'actions'];
        break;
      default:
        this.columns = ['select', 'bridgeAdUnitName', 'sites', 'publisherName', 'status', 'hbId', 'siteId', 'createdOn', 'actions'];
    }
  }

  ngOnInit(): void {
    const customFilterFn = (data: BridgeAdUnitDemandPartnerLine, filter: string) => {
      const statusFilterOk = this.filter.selectedStatuses.length ? this.filter.selectedStatuses.includes(data.status) : true;
      const nameFilterOk = !this.filter.name || data.bridgeAdUnitName.toLowerCase().includes(this.filter.name.toLowerCase());
      const publisherOk = !this.filter.publisherId || data.publisherId === this.filter.publisherId;
      return statusFilterOk && nameFilterOk && publisherOk;
    };
    this.dataSource.filterPredicate = customFilterFn;
    this.refreshData();
  }

  ngAfterViewInit(): void {
    //noinspection TypeScriptUnresolvedFunction
    this.filter.nameControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),)
      .subscribe(data => {
        this.filter.name = data;
        this.filterData();
      });
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  refreshData() {
    this.showLoadingData = true;
    this.data = new BridgeAdUnitDemandPartnerResponse();

    this.getPublishers();
    this.dpStatsService.adUnits(this.filter.selectedStatuses).subscribe(response => {
        this.data = response;
        this.data.adUnits.forEach(adUnit => {
          if (adUnit.domains) {
            adUnit._domainUrls = adUnit.domains.map(d => d.url);
          }
        });
        this.data._numApprovedPct = Utils.pct(response.numApproved, response.numTotal);
        this.data._numPendingPct = Utils.pct(response.numPending, response.numTotal);
        this.data._numRejectedPct = Utils.pct(response.numRejected, response.numTotal);
        this.dataSource.data = JSON.parse(JSON.stringify(this.data.adUnits));
        this.selection.clear();
        this.filterData();
      },
      () => {
        this.showLoadingData = false;
      }, () => {
        this.showLoadingData = false;
      });
  }

  getPublishers() {
    this.dpStatsService.getPublishers(this.filter.selectedStatuses).subscribe(publishers => {
      this.availablePublishers = publishers;
      this.availablePublishers.sort(Utils.sortComparatorByAttribute('name'));
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  exportCsv() {
    const dataToIncludeInCsv = [];
    this.dataSource.data.forEach(unitData => {
      const csvLine = {
        'Ad unit': unitData.bridgeAdUnitName,
        'Sites': unitData._domainUrls.join(','),
        'Publisher name': unitData.publisherName,
        'HB ID': unitData.hbId,
        'Site Id': unitData.siteId,
        'Status': unitData.status,
        'Ads.txt status': this.isIndexOrSovrn ? 'VALID' : unitData.adsTxtStatus,
        'Date created': unitData.createdOn ? MomentDateUtils.format(unitData.createdOn) : null,
      };

      if (this.isUnitActivatedAllowed) {
        csvLine['Unit activated (yes / no)'] = unitData.unitActivated ? 'yes' : 'no';
      }
      dataToIncludeInCsv.push(csvLine);
    });
    CsvExportUtils.exportCsv(dataToIncludeInCsv, 'dp-dashboard-export');
    return dataToIncludeInCsv;
  }

  downloadRonSiteList(element: BridgeAdUnitDemandPartnerLine) {
    Utils.exportBlobCsv(element.ronSiteList, element.bridgeAdUnitName + ' - RON site list.txt');
  }

  getUrl(row) {
    return HttpUtils.appendHttpToUrlIfNotExists(row.siteName);
  }

  filterData() {
    this.dataSource.filter = <string> (this.filter ? this.filter : '');
  }

  updateUnits() {
    const updated = this.dataSource.data;
    const original = this.data.adUnits;

    const dataToUpdate = [];

    original.forEach(o => {
      const u = updated.find(up => o.bridgeAdUnitName === up.bridgeAdUnitName);
      if (u.hbId !== o.hbId ||
        u.status !== o.status ||
        u.siteId !== o.siteId ||
        u.unitActivated !== o.unitActivated
      ) {
        dataToUpdate.push(u);
      }
    });

    this.globalSpinnerService.showLoader();
    this.dpStatsService.adUnitsUpdate(dataToUpdate).subscribe(
      () => {
      },
      () => {
        this.globalSpinnerService.hideLoader();
      },
      () => {
        this.globalSpinnerService.hideLoader();
        this.refreshData();
      }
    );
  }

  openCommentDialog(data: BridgeAdUnitDemandPartnerLine) {
    this.matDialog.open(DemandPartnerRequestDialogComponent, <MatDialogConfig>{
      data: {
        siteName: data.siteName,
        bridgeAdUnitName: data.bridgeAdUnitName,
        bridgeAdUnitId: data.bridgeAdUnitId,
      }
    }).afterClosed().subscribe(next => {
      if (next) {
        this.refreshData();
      }
    });
  }

  approveSelectedUnits() {
    this.selection.selected.forEach(u => {
      u.status = BridgeAdUnitDpHbIdStatus.APPROVED;
    });
    this.updateUnits();
  }

  activateSelectedUnits() {
    this.selection.selected.forEach(u => {
      u.unitActivated = true;
    });
    this.updateUnits();
  }

  rejectSelectedUnits() {
    this.selection.selected.forEach(u => {
      u.status = BridgeAdUnitDpHbIdStatus.REJECTED;
    });
    this.updateUnits();
  }

  downloadCsvTemplate() {
    Utils.exportBlobCsv('HBID,Ad Unit (Consumable Name)', 'HB CSV template.csv');
  }

  uploadFile(file: File) {
    this.globalSpinnerService.showLoader();
    this.dpStatsService.importHbId(file).subscribe((next: HbCsvImportResult) => {
        this.refreshData();
        this.globalSpinnerService.hideLoader();

        if (next.errorsCount > 0) {
          this.matDialog.open(HbCsvImportResultDialogComponent, <MatDialogConfig>{
            data: {
              result: next
            }
          });
        } else {
          this.snackBarService.success('Data imported successfully!');
        }
      },
      () => {
        this.snackBarService.error('Error occured during file upload');
        this.globalSpinnerService.hideLoader();
      });
  }

}
